import { apiPath } from '@helpers/pathHelper';

export const downloadFromApi = (path: string) =>
  window.open(apiPath(path), '_blank');
